const pageTypes = {
  search_results: /^.+\/shop\/search\/(\w+\/)?(flights|hotels)?\?.*(id=\w+-\w+-\w+-\w+-\w+).+$/,
  product_details: /^.+((\/shop\/search\/(\w+\/)?(hotels|flights)\/)|(\/relax\/(\w+\/)?at\/)|(\/m\/fly\/search\/(\w+\/)?.+?\/details\/)).+$/,
  checkout_process: /^.+(\/cart\/checkout\/|\/shop\/search\/(\w+\/)?itinerary).+$/,
  post_booking: /^.+\/travel-itinerary.+$/,
  index: /^.+\/shop\/search(\/\w+)?\/?.*$/,
  landing: /^.+\/vacationpackages(\/\w+)?\/?.*$/,
  landing_flights: /^.+\/flights(\/\w+)?\/?.*$/,
  search_results_flights: /^\S*\/m\/fly\/search\/(?:\w{3}-\w{3}-\d{8}\/).+$/,
  others: /^.+$/
}

export const getType = pageType => {
  switch (pageType) {
    case 'index':
    case 'landing':
    case 'landing_flights':
      return 'landing'
    case 'search_results':
    case 'search_results_flights':
      return 'search'
    case 'product_details':
      return 'details'
    case 'checkout_process':
    case 'post_booking':
      return 'book'
    default:
      return 'other'
  }
}

export const getPageType = url => {
  return Object.keys(pageTypes).find(type => pageTypes[type].test(url))
}
